import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-collapsible-section',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, TranslocoModule],
  templateUrl: './collapsible-section.component.html',
})
export class CollapsibleSectionComponent implements OnInit {
  @Input() title: string = '';
  @Input() icon: string = 'list';
  @Input() storageKey?: string;
  @Input() collapsed: boolean = false;
  @Input() marginWhenOpen: string = 'mb-16';
  @Input() marginWhenCollapsed: string = 'mb-8';

  @Output() collapsedChange = new EventEmitter<boolean>();

  contentId = `collapsible-content-${Math.random().toString(36).slice(2, 9)}`;

  ngOnInit(): void {
    if (this.storageKey) {
      const stored = localStorage.getItem(this.storageKey);
      if (stored !== null) {
        this.collapsed = stored === 'true';
      }
    }
  }

  toggle(): void {
    this.collapsed = !this.collapsed;

    if (this.storageKey) {
      localStorage.setItem(this.storageKey, this.collapsed.toString());
    }

    this.collapsedChange.emit(this.collapsed);
  }
}
